import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import HeroSection from '@/components/landing/HeroSection'
import BentoFeatures from '@/components/landing/BentoFeatures'
import ProductPreview from '@/components/landing/ProductPreview'
import { useLang } from '@/hooks/useLang'
import { useAudio } from '@/hooks/useAudio'

export default function LandingPage() {
  const { lang, toggle: toggleLang } = useLang()
  const { enabled: audioEnabled, playing: audioPlaying, toggle: toggleAudio } = useAudio(lang)

  return (
    <div className="min-h-screen bg-surface text-on-surface overflow-x-hidden selection:bg-primary-container selection:text-on-primary-container">
      <Header
        lang={lang}
        audioEnabled={audioEnabled}
        audioPlaying={audioPlaying}
        onToggleAudio={toggleAudio}
        onToggleLang={toggleLang}
      />

      <main className="relative pt-20">
        <HeroSection lang={lang} />
        <BentoFeatures lang={lang} />
        <ProductPreview lang={lang} />
      </main>

      <Footer lang={lang} />
    </div>
  )
}
